/* global RdcTracking */

// Direct call rules are any custom event that don't fit into any general category.

const DEFAULT_VALUE = 'unknown';

export const trackAdblock = function(isAdBlockEnabled) {
  RdcTracking.trackEvent('adBlockerDetection', isAdBlockEnabled);
}

export const trackRcmLead = function(pd) {
  const props = {
    city: pd.listingCity,
    creditScore: pd.leadCreditScore,
    forSaleLeads: `web:leads:${pd.leadType}:${pd.leadPlacement}`,
    listingId: pd.listingId,
    listingPrice: pd.listingPrice,
    pageType: pd.pageType,
    state: pd.listingState,
    zip: pd.listingZip,
  }
  RdcTracking.trackEvent('rcmLead', props);
}

export const trackMovingQuoteLead = function(selfIdentify, leadPlacement) {
  const props = {
    dsSegment: selfIdentify,
    movingQuotes: leadPlacement,
    modalName: leadPlacement
  };
  RdcTracking.trackEvent('movingQuoteLead', props);
}

export const trackCommuteTime = function(pageType, commuteAddress, commuteOption) {
  const props = {
    linkName: `${pageType}:property-info:calculate-commute:success`,
    commuteAddress,
    commuteOption,
  };
  RdcTracking.trackEvent('click', props);
}

export const trackHomesNearStreetPinClick = function(pd={}) {
  const props = {
    communityId: pd.communityId || pd.community_id,
    listingId: pd.listingID || pd.listing_id,
    planId: pd.planID || pd.plan_id,
    productType: pd.productType || pd.product_type,
    propertyStatus: pd.propertyStatus || pd.status,
    propertyStatusSub: pd.propertyStatusSub || DEFAULT_VALUE,
    searchId: pd.searchID || pd.search_id,
    subId: pd.subID || pd.subdivision_id
  }
  RdcTracking.trackEvent('srp:map:mini-card:impression', props);
}

export const trackHistoricalValueGraph = function() {
  RdcTracking.trackEvent('click', { linkName: 'ldp:historical-value-graph:interact' });
}

export const trackPaymentCalculator = function() {
  RdcTracking.trackEvent('click', { linkName: 'finance:calculator:success' });
}

export const trackBranchBannerClose = function() {
  RdcTracking.trackEvent('click', { linkName: 'email:branch:close' });
}



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/special_events.js